"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRMIdentifier = void 0;
var TRMIdentifier;
(function (TRMIdentifier) {
    TRMIdentifier["ALGORAND"] = "algorand";
    TRMIdentifier["ARBITRUM"] = "arbitrum";
    TRMIdentifier["AVALANCHE"] = "avalanche_c_chain";
    TRMIdentifier["BINANCE"] = "binance";
    TRMIdentifier["BINANCE_SMART_CHAIN"] = "binance_smart_chain";
    TRMIdentifier["BITCOIN"] = "bitcoin";
    TRMIdentifier["BITCOIN_CASH"] = "bitcoin_cash";
    TRMIdentifier["BYTOM"] = "bytom";
    TRMIdentifier["CARDANO"] = "cardano";
    TRMIdentifier["CELO"] = "celo";
    TRMIdentifier["COSMOS"] = "cosmos";
    TRMIdentifier["DASH"] = "dash";
    TRMIdentifier["DOGECOIN"] = "dogecoin";
    TRMIdentifier["ELASTOS"] = "elastos";
    TRMIdentifier["ETHEREUM"] = "ethereum";
    TRMIdentifier["ETHEREUM_CLASSIC"] = "ethereum_classic";
    TRMIdentifier["ELROND"] = "elrond";
    TRMIdentifier["FILECOIN"] = "filecoin";
    TRMIdentifier["HEDERA"] = "hedera";
    TRMIdentifier["ICON"] = "icon";
    TRMIdentifier["IOST"] = "iost";
    TRMIdentifier["IOTA"] = "iota";
    TRMIdentifier["KLAYTN"] = "klaytn";
    TRMIdentifier["LISK"] = "lisk";
    TRMIdentifier["LITECOIN"] = "litecoin";
    TRMIdentifier["MONERO"] = "monero";
    TRMIdentifier["NEBULAS"] = "nebulas";
    TRMIdentifier["NEO"] = "neo";
    TRMIdentifier["OASIS"] = "oasis";
    TRMIdentifier["OMNI"] = "omni";
    TRMIdentifier["ONTOLOGY"] = "ontology";
    TRMIdentifier["OPTIMISM"] = "optimism";
    TRMIdentifier["PAI"] = "pai";
    TRMIdentifier["POLKADOT"] = "polkadot";
    TRMIdentifier["POLYGON"] = "polygon";
    TRMIdentifier["QTUM"] = "qtum";
    TRMIdentifier["XRPLEDGER"] = "ripple";
    TRMIdentifier["SOLANA"] = "solana";
    TRMIdentifier["STEEM"] = "steem";
    TRMIdentifier["STELLAR"] = "stellar";
    TRMIdentifier["TEZOS"] = "tezos";
    TRMIdentifier["TRON"] = "tron";
    TRMIdentifier["ZCASH"] = "zcash";
    TRMIdentifier["ZILLIQA"] = "zilliqa";
})(TRMIdentifier || (exports.TRMIdentifier = TRMIdentifier = {}));
//# sourceMappingURL=index.js.map